import { InternalLink, P } from "@sorcery/ui";

import { DeckDividerEnum } from "~/types/deck";
import type { UserPageType } from "~/types/user";
import { decksPath, userPath } from "~/utils/paths";

export const UserFollowing = ({
  user,
  slim,
}: {
  user: UserPageType;
  slim?: boolean;
}) => {
  return (
    <div className={`!mb-8 overflow-auto ${slim && "max-h-24"} max-w-lg`}>
      {!slim &&
        (user.following.length === 0 ? (
          <>
            <P className="!mb-1">None yet...</P>
            <P>
              Explore the deck library and take notice of your favorite authors. Follow them to keep
              up with their latest creations.
            </P>
          </>
        ) : (
          <P className="!mb-1">
            <span>Explore their latest creations in the</span>{" "}
            <InternalLink
              color={"primary"}
              href={`${decksPath}?search=${DeckDividerEnum.FOLLOWING}`}
            >
              deck library
            </InternalLink>{" "}
            <span>
              by clicking the "Following" option. A true Sorcerer takes inspiration from the best...
            </span>
          </P>
        ))}
      {user.following.map((u, i) => (
        <span key={u.id}>
          <span className="hover:underline">
            <InternalLink href={userPath(u.id)} className="text-red">
              @{u.username}
            </InternalLink>
          </span>
          {i !== user.following.length - 1 && ","}
        </span>
      ))}
    </div>
  );
};
